const BMFF = module.exports = {}

BMFF.findBox = function(box, path) {
  path.split('.').forEach(type=>{
    box = box._b.filter(b=>b._t==type)[0]
  })
  return box
} // findBox

BMFF.getValue = function(box, path) {
  path = path.split('.')
  const field = path.pop()
  box = BMFF.findBox(box, path.join('.'))
  return box ? box[field] : undefined
} // getValue

BMFF.setValue = function(box, path, value) {
  path = path.split('.')
  const field = path.pop()
  box = BMFF.findBox(box, path.join('.'))
  if(box) box[field] = value
} // setValue

BMFF.deleteBox = function(box, path) {
  path = path.split('.')
  const box_to_delete = path.pop()
  const parent_box = path.length>0 ? BMFF.findBox(box, path.join('.')) : box
  if(parent_box && parent_box._b) {
    if(/^\d+$/.test(box_to_delete)) {
      // delete n-th box when pure number
      parent_box._b.splice(box_to_delete, 1)
    }else {
      // otherwise delete boxes of given type
      parent_box._b = parent_box._b.filter(b=>b._t!=box_to_delete)
    }
  }
} // deleteBox

BMFF.composeBox = function(box) {
  const type = box._t
  let parts = null
  if('_d' in box) {
    parts = [BMFF.hex2bytes(box._d)]
  }else if(BMFF['compose_'+type]) {
    try{
      parts = BMFF['compose_'+type](box)
    }catch(e) {
      console.error(e)
    }
  }else if(BMFF.BOXES[type]) {
    parts = BMFF.composeFields(BMFF.BOXES[type], box)
  }else{
    console.error('Cannot compose box of type: '+type, box)
  }

  if(!parts || parts.length===0) return new Uint8Array(0)

  const size = parts.reduce((total, x) => total + x.byteLength, 0)
  const uint = new Uint8Array(size+8)
  const view = new DataView(uint.buffer, 0, 8)
  view.setUint32(0, size+8)
  view.setUint8(4, type.charCodeAt(0))
  view.setUint8(5, type.charCodeAt(1))
  view.setUint8(6, type.charCodeAt(2))
  view.setUint8(7, type.charCodeAt(3))
  let idx = 8
  parts.forEach(part=>{
    uint.set(new Uint8Array(part), idx)
    idx+=part.byteLength
  })
  return uint
} // composeBox

BMFF.composeFields = function(fields, box) {
  const parts = []
  for(let i=0; i+1<fields.length; i+=2) {
    const name = fields[i]
    let [, flag, op, val, fulltype, type, byteLength] = /^(?:(\w+)(&|=)(\d+)\?)?(([a-zA-Z]*)(\d*))$/.exec(fields[i+1])
    byteLength = parseInt(byteLength) || 0

    // skip conditional field if condition not satisfied
    if(op==='&') {
      if(!(box[flag] & val)) continue
    }else if(op==='=') {
      if(!(box[flag] == val)) continue
    }else if(op==='!=') {
      if(box[flag] == val) continue
    }else if(op) {
      console.error('invalid operator '+op)
    }

    let value = box[name]

    if(type==='boxes') {
      value.forEach(child=>parts.push(BMFF.composeBox(child)))
    }else if(type==='string' || type==='buffer') {
      value =
          type==='string' ? BMFF.ascii2bytes(value) :
            typeof (value)==='string' ? BMFF.hex2bytes(value) :
              typeof (value)==='undefined' || value==null ? new Uint8Array(0) :
                value
      if(byteLength) {
        if(value.byteLength > byteLength) {
          value = value.slice(0, byteLength)
        }else if(value.byteLength < byteLength) {
          const new_value = new Uint8Array(byteLength)
          new_value.set(value)
          value = new_value
        }
      }
      parts.push(value)
    }else{
      // numeric value
      const uint = new Uint8Array(byteLength)
      const view = new DataView(uint.buffer)
      if(fulltype==='uint1') {
        view.setUint8(0, value & 0xFF)
      }else if(fulltype==='uint2') {
        view.setUint16(0, value & 0xFFFF)
      }else if(fulltype==='uint3') {
        view.setUint8(0, parseInt(value/0x10000) % 0x100)
        view.setUint8(1, parseInt(value % 0x10000 / 0x100) % 0x100)
        view.setUint8(2, value % 0x100)
      }else if(fulltype==='uint4') {
        view.setUint32(0, value)
      }else if(fulltype==='time4') {
        view.setUint32(0, value)
      }else if(fulltype==='uint8') {
        view.setUint32(0, value / 0x100000000)
        view.setUint32(4, value % 0x100000000)
      }else if(fulltype==='fixed2') {
        view.setUint8(0, parseInt(value % 0x100))
        view.setUint8(1, parseInt(value * 100 % 100))
      }else if(fulltype==='fixed4') {
        view.setUint16(0, parseInt(value % 0x10000))
        view.setUint16(2, parseInt(value * 10000 % 10000))
      }else{
        console.error('unknown type: ', fulltype)
      }
      parts.push(uint)
    }
  }

  return parts
} // composeFields

BMFF.compose_avcC = function(box) {
  const parts = [
    new Uint8Array([
      box.configurationVersion,
      box.AVCProfileIndication,
      box.profileCompatibility,
      box.AVCLevelIndication,
      box.lengthSizeMinusOne | 0xFC,
      box.sequenceParameterSets.length | 0xE0,
    ]),
  ]

  box.sequenceParameterSets.forEach(set=>{
    if(typeof set==='string') set = BMFF.hex2bytes(set)
    parts.push(
      new Uint8Array([parseInt(set.byteLength/0x100), set.byteLength%0x100]),
      set,
    )
  })

  parts.push(new Uint8Array([box.pictureParameterSets.length]))

  box.pictureParameterSets.forEach(set=>{
    if(typeof set==='string') set = BMFF.hex2bytes(set)
    parts.push(
      new Uint8Array([parseInt(set.byteLength/0x100), set.byteLength%0x100]),
      set,
    )
  })

  return parts
} // compose_avcC

BMFF.parseBox = function(bytes) {
  bytes = BMFF.getBuffer(bytes)
  const view = new DataView(bytes)
  if(bytes.byteLength<8) return
  const size = view.getUint32(0)
  if(bytes.byteLength<size) return
  const type = BMFF.bytes2ascii(bytes.slice(4, 8))
  const data = bytes.slice(8, size)
  let box
  if(BMFF['parse_'+type]) {
    // custom parsing available
    try{
      box = BMFF['parse_'+type](data)
    }catch(e) {
      console.error(e)
      box = { _t: type, _d: BMFF.bytes2hex(data) }
    }
  }else if(BMFF.BOXES[type] && BMFF.BOXES[type].length>0) {
    box = BMFF.parseFields(BMFF.BOXES[type], data)
  }else{
    box = { _t: type, _d: BMFF.bytes2hex(data) }
  }
  box._t = type
  return box
} // parseBox

BMFF.parseBoxes = function(bytes) {
  bytes = BMFF.getBuffer(bytes)
  const boxes = []
  let box
  while((box = BMFF.parseBox(bytes))) {
    boxes.push(box)
    const view = new DataView(bytes)
    bytes = bytes.slice(view.getUint32(0)) // skip length of the box just parsed
  }
  return boxes
} // parseBoxes

BMFF.parseFields = function(fields, bytes) {
  bytes = BMFF.getBuffer(bytes)
  const view = new DataView(bytes)
  const values = { _t: '' } // to ensure _t is the first field in the hash for better debugging
  let idx=0
  for(let i=0; i+1<fields.length; i+=2) {
    if(idx>=bytes.byteLength) break
    const name = fields[i]
    const m = /^(?:(\w+)(&|=)(\d+)\?)?(\w+)$/.exec(fields[i+1])
    if(!m) continue
    const [, flag, op, val, type] = m
    if(op==='&') {
      if(!(values[flag] & val)) continue
    }else if(op==='=') {
      if(!(values[flag] == val)) continue
    }else if(op==='!=') {
      if(values[flag] == val) continue
    }else if(op) {
      console.error('invalid operator '+op)
    }
    if(type==='boxes') {
      values[name] = BMFF.parseBoxes(bytes.slice(idx))
      break
    }else if(type==='uint1') {
      values[name] = view.getUint8(idx)
      idx++
    }else if(type==='uint2') {
      values[name] = view.getUint16(idx)
      idx+=2
    }else if(type==='uint3') {
      values[name] = view.getUint8(idx)*0x10000 + view.getUint16(idx+1)
      idx+=3
    }else if(type==='uint4') {
      values[name] = view.getUint32(idx)
      idx+=4
    }else if(type==='uint8') {
      values[name] = view.getUint32(idx+1)*0x100000000 + view.getUint32(idx+4)
      idx+=8
    }else if(type==='time4') {
      values[name] = view.getUint32(idx)
      idx+=4
    }else if(type==='fixed2') {
      values[name] = view.getUint8(idx)+'.'+view.getUint8(idx+1)
      idx+=2
    }else if(type==='fixed4') {
      values[name] = view.getUint16(idx)+'.'+view.getUint16(idx+2)
      idx+=4
    }else if(/^string/.test(type)) {
      let length = parseInt(type.substr(6))
      if(isNaN(length)) length = bytes.byteLength-idx
      values[name] = BMFF.bytes2ascii(bytes.slice(idx, idx+length))
      idx+=length
    }else if(/^buffer/.test(type)) {
      let length = parseInt(type.substr(6))
      if(isNaN(length)) length = bytes.byteLength-idx
      values[name] = BMFF.bytes2hex(bytes.slice(idx, idx+length))
      idx+=length
    }else{
      console.warn('unsupported field type: '+type)
    }
  }

  delete values['']
  return values
} // parseFields

BMFF.parse_avcC = function(bytes) {
  bytes = BMFF.getBuffer(bytes)
  const uint = new Uint8Array(bytes)
  const fields = {
    _t: 'avcC', // to ensure _t is the first field in the hash for better debugging
    configurationVersion: uint[0],
    AVCProfileIndication: uint[1],
    profileCompatibility: uint[2],
    AVCLevelIndication: uint[3],
    lengthSizeMinusOne: parseInt(uint[4] & 0b11),
    sequenceParameterSets: [],
    pictureParameterSets: [],
  }
  bytes = bytes.slice(5)

  const spsCount = parseInt(uint[0] & 0b11111)
  bytes = bytes.slice(1)
  for(let i=0; i<spsCount; i++) {
    const view = new DataView(bytes)
    const len = view.getUint16(0)
    const sps = BMFF.bytes2hex(bytes.slice(2, len+2))
    fields.sequenceParameterSets.push(sps)
    bytes = bytes.slice(len+2)
  }

  const ppsCount = uint[0]
  bytes = bytes.slice(1)
  for(let i=0; i<ppsCount; i++) {
    const view = new DataView(bytes)
    const len = view.getUint16(0)
    const pps = BMFF.bytes2hex(bytes.slice(2, len+2))
    fields.pictureParameterSets.push(pps)
    bytes = bytes.slice(len+2)
  }

  return fields
} // parse_avcC

BMFF.parseSPS = function(sps_hex) {
  let bits

  function readBits(num) {
    return parseInt(bits.splice(0, num).join(''), 2)
  }

  function readExpGolomb() {
    let cnt = 0
    while(!bits[cnt]) cnt++
    const value_bits = bits.slice(cnt, cnt*2+1)
    bits = bits.slice(cnt*2+1)
    return parseInt(value_bits.join(''), 2)-1
  }

  function skipScalingList(count) {
    const seq_scaling_list_present_flags = readBits(1)
    if(!seq_scaling_list_present_flags) return
    let lastScale = 8; let nextScale = 8; let deltaScale
    for(let j=0; j<count; j++) {
      if(nextScale) {
        deltaScale = readExpGolomb()
        nextScale = (lastScale + deltaScale + 256) % 256
      }
      lastScale = nextScale || lastScale
    }
  }

  bits =
    sps_hex instanceof Uint8Array ? Array.from(sps_hex).map(x=>parseInt(x).toString(2).padStart(8, '0')).join('').split('').map(x=>parseInt(x)) :
      sps_hex.match(/(..)/g).map(x=>parseInt(x, 16).toString(2).padStart(8, '0')).join('').split('').map(x=>parseInt(x))

  const sps = {
    frameCropLeftOffset: 0,
    frameCropRightOffset: 0,
    frameCropTopOffset: 0,
    frameCropBottomOffset: 0,
    sarScale: 1,
  }

  sps.header = readBits(8)
  sps.profileIdc = readBits(8)
  sps.profileCompat = readBits(5)
  readBits(3)
  sps.levelIdc = readBits(8)
  sps.seq_parameter_set_id = readExpGolomb()
  if([44, 83, 86, 100, 110, 118, 122, 128, 244].indexOf(sps.profileIdc)>=0) {
    // some profiles have more optional data we don't need
    sps.chromaFormatIdc = readExpGolomb()
    if(sps.chromaFormatIdc === 3) readBits(1) // separate_colour_plane_flag
    sps.bit_depth_luma_minus8 = readExpGolomb()
    sps.bit_depth_chroma_minus8 = readExpGolomb()
    sps.qpprime_y_zero_transform_bypass_flag = readBits(1)
    sps.seq_scaling_matrix_present_flag = readBits(1)
    if(sps.seq_scaling_matrix_present_flag) {
      sps.scalingListCount = sps.chromaFormatIdc===3 ? 12 : 8
      for(let i=0; i<sps.scalingListCount; i++) {
        skipScalingList(i<6 ? 16 : 64)
      }
    }
  }
  sps.log2_max_frame_num_minus4 = readExpGolomb()
  sps.picOrderCntType = readExpGolomb()
  if(sps.picOrderCntType===0) {
    sps.log2_max_pic_order_cnt_lsb_minus4 = readExpGolomb()
  }else if(sps.picOrderCntType===1) {
    sps.delta_pic_order_always_zero_flag = readBits(1)
    sps.offset_for_non_ref_pic = readExpGolomb()
    sps.offset_for_top_to_bottom_field = readExpGolomb()
    sps.numRefFramesInPicOrderCntCycle = readExpGolomb()
    for(let i = 0; i<sps.numRefFramesInPicOrderCntCycle; i++) readExpGolomb() // offset_for_ref_frame[i]
  }
  sps.max_num_ref_frames = readExpGolomb()
  sps.gaps_in_frame_num_value_allowed_flag = readBits(1)
  sps.picWidthInMbsMinus1 = readExpGolomb()
  sps.picHeightInMapUnitsMinus1 = readExpGolomb()
  sps.frameMbsOnlyFlag = readBits(1)
  if(!sps.frameMbsOnlyFlag) sps.mb_adaptive_frame_field_flag = readBits(1)
  sps.direct_8x8_inference_flag = readBits(1)
  sps.frame_cropping_flag = readBits(1)
  if(sps.frame_cropping_flag) {
    sps.frameCropLeftOffset = readExpGolomb()
    sps.frameCropRightOffset = readExpGolomb()
    sps.frameCropTopOffset = readExpGolomb()
    sps.frameCropBottomOffset = readExpGolomb()
  }
  sps.vui_parameters_present_flag = readBits(1)
  if(sps.vui_parameters_present_flag) {
    sps.aspect_ratio_info_present_flag = readBits(1)
    if(sps.aspect_ratio_info_present_flag) {
      sps.aspectRatioIdc = readBits(8)
      const RATIOS = [null, [1, 1], [12, 11], [10, 11], [16, 11], [40, 33], [24, 11], [20, 11], [32, 11], [80, 33], [18, 11], [15, 11], [64, 33], [160, 99], [4, 3], [3, 2], [2, 1]]
      sps.sarRatio = RATIOS[sps.aspectRatioIdc]
      if(sps.aspectRatioIdc===255) sps.sarRatio = [readBits(16), readBits(16)]
      if(sps.sarRatio) sps.sarScale = sps.sarRatio[0] / sps.sarRatio[1]
    }
  }
  sps.width = Math.ceil((((sps.picWidthInMbsMinus1 + 1) * 16) - sps.frameCropLeftOffset * 2 - sps.frameCropRightOffset * 2) * sps.sarScale)
  sps.height = ((2 - sps.frameMbsOnlyFlag) * (sps.picHeightInMapUnitsMinus1 + 1) * 16) - ((sps.frameMbsOnlyFlag? 2 : 4) * (sps.frameCropTopOffset + sps.frameCropBottomOffset))
  return sps
} // parseSPS

BMFF.dump = function(box, max_bytes, indent) {
  indent = indent || ''
  console.log(indent+box._t)
  for(const p in box) {
    let value = box[p]
    if(value instanceof Buffer) value = BMFF.getBuffer(value)
    if(value instanceof Uint8Array) {
      console.log(`${indent}  ${p}(${value.byteLength}): ${BMFF.bytes2hex(value)}`)
    }else if(Array.isArray(value)) {
      if(p==='_b') {
        value.forEach(child=>BMFF.dump(child, max_bytes, indent+'  '))
      }else{
        console.log(`${indent}  ${p}: [`)
        value.forEach(item=>{
          let str, len
          if(item instanceof Buffer || item instanceof ArrayBuffer || (typeof item==='object' && item.buffer)) {
            const bytes = BMFF.getBuffer(item)
            len = bytes.byteLength
            if(max_bytes>0 && len>max_bytes) {
              str = BMFF.bytes2hex(bytes.slice(0, max_bytes))+' ...'
            }else {
              str = BMFF.bytes2hex(bytes)
            }
          }else{
            str = String(item)
            len = str.length
          }
          if(p==='sequenceParameterSets') {
            const sps = BMFF.parseSPS(BMFF.hex2bytes(str))
            str = str + Object.keys(sps).map(pp=>`\n${indent}      ${pp}: ${sps[pp]}`).join('')
          }
          console.log(`${indent}    ${str} `)
        })
        console.log(`${indent}  ]`)
      }
    }else if(p==='_d') {
      const len = value.length/2
      if(max_bytes>0 && value.length>max_bytes*2) value = value.substr(0, max_bytes*2)+'...'
      console.log(`${indent}  ${p}: ${value} (${len} bytes)`)
    }else if(p!=='_t') {
      console.log(`${indent}  ${p}: ${value}`)
    }
  }
} // dump

BMFF.getBuffer = function(buf) {
  if(typeof Buffer==='function' && buf instanceof Buffer) { return buf.buffer.slice(buf.byteOffset, buf.byteOffset+buf.length) }
  if(buf instanceof ArrayBuffer) { return buf }
  if(typeof buf==='object' && buf.buffer) { return buf.buffer }
  return new ArrayBuffer()
} // getBuffer

BMFF.hex2bytes = function(str) {
  if(str instanceof Uint8Array) return str
  if(str==null || typeof str==='undefined' || str==='') return new Uint8Array(0)
  try{
    const bytes = new Uint8Array(str.match(/(..)/g).map(x=>parseInt(x, 16)))
    return bytes
  }catch(e) {
    console.error('Cannot transform hex2bytes: '+e)
    return new Uint8Array(0)
  }
} // hex2bytes

BMFF.bytes2hex = function(bytes) {
  bytes = BMFF.getBuffer(bytes)
  const out = Array.prototype.map.call(new Uint8Array(bytes), x => ('00' + x.toString(16)).slice(-2)).join('')
  return out
} // bytes2hex

BMFF.bytes2human = function(bytes) {
  bytes = BMFF.getBuffer(bytes)
  return Array.prototype.map.call(new Uint8Array(bytes), x => (('00' + x.toString(16)).slice(-2))+' ').join('').replace(/ $/, '').toUpperCase()
} // bytes2human

BMFF.bytes2ascii = function(bytes) {
  bytes = BMFF.getBuffer(bytes)
  return String.fromCharCode.apply(null, new Uint8Array(bytes))
} // bytes2ascii

BMFF.hex2ascii = function(str) {
  return String.fromCharCode.apply(null, BMFF.hex2bytes(str.replace(/\s+/g, '')))
} // hex2ascii

BMFF.ascii2bytes = function(str) {
  const bytes = new ArrayBuffer(str.length)
  const view = new Uint8Array(bytes)
  for(let i=0, strLen=str.length; i < strLen; i++) view[i] = str.charCodeAt(i)
  return bytes
} // ascii2bytes

BMFF.getTemplate = function(name) {
  return JSON.parse(BMFF.TEMPLATES[name])
} // getTemplate

BMFF.BOXES = {
  // file type and compatibility
  ftyp: [
    'major', 'string4',
    'minor', 'uint4',
    'compatibility_brands', 'string',
  ],

  // container for all the metadata
  moov: ['_b', 'boxes'],

  // movie header, overall declarations
  mvhd: [
    'version', 'uint1',
    'flags', 'uint3',
    'creationTime', 'time4',
    'modificationTime', 'time4',
    'timeScale', 'uint4',
    'duration', 'uint4',
    'preferredRate', 'fixed4',
    'preferredVolume', 'fixed2',
    'reserved1', 'buffer10',
    'matrixStructure', 'buffer36',
    'previewTime', 'uint4',
    'previewDuration', 'uint4',
    'posterTime', 'uint4',
    'selectionTime', 'uint4',
    'selectionDuration', 'uint4',
    'currentTime', 'uint4',
    'nextTrackId', 'uint4',
  ],

  // container for an individual track or stream
  trak: ['_b', 'boxes'],

  // track header, overall information about the track
  tkhd: [
    'version', 'uint1',
    'flags', 'uint3',
    'creationTime', 'time4',
    'modificationTime', 'time4',
    'trackId', 'uint4',
    'reserved1', 'buffer4',
    'duration', 'uint4',
    'reserved2', 'buffer8',
    'layer', 'uint2',
    'alternateGroup', 'uint2',
    'volume', 'fixed2',
    'reserved3', 'buffer2',
    'matrixStructure', 'buffer36',
    'trackWidth', 'fixed4',
    'trackHeight', 'fixed4',
  ],

  // edit box
  edts: ['_b', 'boxes'],

  // edit list box
  elst: [
    'version', 'uint1',
    'flags', 'uint3',
    'count', 'uint4',
    'entries', 'buffer',
  ],

  // container for the media information in a track
  mdia: ['_b', 'boxes'],

  // media header, overall information about the media
  mdhd: [
    'version', 'uint1',
    'flags', 'uint3',
    'creationTime', 'time4',
    'modificationTime', 'time4',
    'timeScale', 'uint4',
    'duration', 'uint4',
    'language', 'uint2',
    'quality', 'uint2',
  ],

  // Media handler reference atom
  hdlr: [
    'version', 'uint1',
    'flags', 'uint3',
    'componentType', 'string4',
    'componentSubtype', 'string4',
    'componentManufacturer', 'uint4',
    'componentFlags', 'uint4',
    'componentFlagsMask', 'uint4',
    'componentName', 'string',
  ],

  // media information container
  minf: ['_b', 'boxes'],

  // video media header, overall information
  vmhd: [
    'version', 'uint1',
    'flags', 'uint3',
    'graphicsMode', 'uint2',
    'opcolor_red', 'uint2',
    'opcolor_green', 'uint2',
    'opcolor_blue', 'uint2',
  ],

  // null media header, used for subtitles
  nmhd: [
    'version', 'uint1',
    'flags', 'uint3',
  ],

  // data information box, container
  dinf: ['_b', 'boxes'],

  // data reference box, declares source(s) of media data in track
  dref: [
    'version', 'uint4',
    'count', 'uint4',
    '_b', 'boxes',
  ],

  //
  'url ': [
  ],

  // sample table box, container for the time/space map
  stbl: ['_b', 'boxes'],

  // Sample-to-chunk atom
  stsc: [
    'version', 'uint1',
    'flags', 'uint3',
    'count', 'uint4',
    'entries', 'buffer',
  ],

  // Sync sample atom
  stss: [
    'version', 'uint1',
    'flags', 'uint3',
    'count', 'uint4',
    'entries', 'buffer',
  ],

  // sample descriptions (codec types, initialization etc.)
  stsd: [
    'version', 'uint1',
    'flags', 'uint3',
    'count', 'uint4',
    '_b', 'boxes',
  ],

  // H264 video box
  avc1: [
    'reserved1', 'buffer6',
    'dataReferenceIndex', 'uint2',

    'version', 'uint2',
    'revisionLevel', 'uint2',
    'vendor', 'uint4',
    'temporalQuality', 'uint4',
    'spatialQuality', 'uint4',

    'width', 'uint2',
    'height', 'uint2',
    'horizontalResolution', 'fixed4',
    'verticalResolution', 'fixed4',
    'dataSize', 'uint4',

    'frameCount', 'uint2',
    'compressorName', 'string32',
    'depth', 'uint2',
    'colorTableId', 'uint2',

    '_b', 'boxes',
  ],

  //
  pasp: [
    'hSpacing', 'uint4',
    'vSpacing', 'uint4',
  ],

  // 3GPP Timed Text box
  // 0,0,0,0, 1, 255, 0,0,0,0, 0,0, 0,0, 0,0, 0,0, 0,0,0,0, 0,1, 0, 18, 255,255,255,255
  //
  tx3g: [
    'reserved1', 'buffer6',
    'dataReferenceIndex', 'uint2',
    'display_flags', 'uint4', // 0,0,0,0,
    'halign', 'uint1', // 0=left, 1=center, -1=right
    'valign', 'uint1', // 0=top, 1=center, -1=bottom
    'bgcolor', 'uint4', // RGBA
    'box_top', 'uint2', // 0,0,
    'box_left', 'uint2', // 0,0,
    'box_bottom', 'uint2', // 0,0,
    'box_right', 'uint2', // 0,0,
    'style', 'uint4', // 0,0,0,0,
    'font_id', 'uint2', // 0,1,
    'font_face', 'uint1', // 0
    'font_size', 'uint1', // 18; should be 0.05*video_height
    'color', 'uint4', // RGBA: 255,255,255,255
    '_b', 'boxes',
  ],

  // Font Table atom
  // 0,1, 0,1, 5, 83,101,114,105,102
  ftab: [
    'count', 'uint2', // 0,1,
    'font_id', 'uint2', // 0,1,
    'font_name_length', 'uint1', // 5
    'font_name', 'string', // 83,101,114,105,102 = Serif; Must be either “Serif” or “Sans-Serif”.
  ],

  // Time-to-sample atom
  stts: [
    'version', 'uint1',
    'flags', 'uint3',
    'count', 'uint4',
    'entries', 'buffer',
  ],

  // Sample size atom
  stsz: [
    'version', 'uint1',
    'flags', 'uint3',
    'size', 'uint4',
    'count', 'uint4',
    'entries', 'buffer',
  ],

  // Chunk offset atom
  stco: [
    'version', 'uint1',
    'flags', 'uint3',
    'count', 'uint4',
    'entries', 'buffer',
  ],

  // movie extends box
  mvex: [
    '_b', 'boxes',
  ],

  // track extends defaults 24b
  trex: [
    'version', 'uint1',
    'flags', 'uint3',
    'trackId', 'uint4',
    'sampleDescriptionIndex', 'uint4',
    'defaultSampleDuration', 'uint4',
    'defaultSampleSize', 'uint4',
    'defaultSampleFlags', 'uint4',
  ],

  // user-data
  udta: ['_b', 'boxes'],

  // metadata
  meta: [],

  // metadata item list
  ilst: ['_b', 'boxes'],

  // Movie Fragment Box
  moof: ['_b', 'boxes'],

  // Movie Fragment Header Box
  mfhd: [
    'version', 'uint1',
    'flags', 'uint3',
    'sequenceNumber', 'uint4',
  ],

  // Track Fragment Box
  traf: ['_b', 'boxes'],

  // Track Fragment Header Box
  tfhd: [
    'version', 'uint1',
    'flags', 'uint3',
    'trackId', 'uint4',
    'baseDataOffset', 'flags&1?uint8',
    'sampleDescriptionIndex', 'flags&2?uint4',
    'defaultSampleDuration', 'flags&8?uint4',
    'defaultSampleSize', 'flags&16?uint4',
    'defaultSampleFlags', 'flags&32?uint4',
  ],

  // Track Fragment Decode Time Box
  tfdt: [
    'version', 'uint1',
    'flags', 'uint3',
    'baseMediaDecodeTime', 'version=1?uint8',
    'baseMediaDecodeTime', 'version=0?uint4',
    // "trackFragmentDuration", "version=1?uint8",
    // "trackFragmentDuration", "version=0?uint4",
    'ntpTimestampInteger', 'flags&1?uint4',
    'ntpTimestampFraction', 'flags&1?uint4',
  ],

  // Track Fragment Run Box
  trun: [
    'version', 'uint1',
    'flags', 'uint3',
    'sampleCount', 'uint4',
    'dataOffset', 'flags&1?uint4',
    'firstSampleFlags', 'flags&4?uint4',
    'samplesData', 'buffer',
  ],
} // BOXES

BMFF.TEMPLATES = {
  ftyp: {
    _t: 'ftyp',
    major: 'isom',
    minor: 512,
    compatibility_brands: 'isomiso2avc1mp41',
  }, // ftyp

  moov: {
    _t: 'moov',
    _b: [
      {
        _t: 'mvhd',
        version: 0,
        flags: 0,
        creationTime: '1904-01-01T00:00:00.000Z',
        modificationTime: '1904-01-01T00:00:00.000Z',
        timeScale: 1000,
        duration: 0,
        preferredRate: '1.0',
        preferredVolume: '1.0',
        reserved1: '00000000000000000000',
        matrixStructure: '000100000000000000000000000000000001000000000000000000000000000040000000',
        previewTime: 0,
        previewDuration: 0,
        posterTime: 0,
        selectionTime: 0,
        selectionDuration: 0,
        currentTime: 0,
        nextTrackId: 2,
      },
    ],
  }, // moov

  trak: {
    _t: 'trak',
    _b: [
      {
        _t: 'tkhd',
        version: 0,
        flags: 3,
        creationTime: '1904-01-01T00:00:00.000Z',
        modificationTime: '1904-01-01T00:00:00.000Z',
        trackId: 1,
        reserved1: '00000000',
        duration: 0,
        reserved2: '0000000000000000',
        layer: 0,
        alternateGroup: 0,
        volume: '0.0',
        reserved3: '0000',
        matrixStructure: '000100000000000000000000000000000001000000000000000000000000000040000000',
        trackWidth: '1280.0',
        trackHeight: '960.0',
      },
      {
        _t: 'mdia',
        _b: [
          {
            _t: 'mdhd',
            version: 0,
            flags: 0,
            creationTime: '1904-01-01T00:00:00.000Z',
            modificationTime: '1904-01-01T00:00:00.000Z',
            timeScale: 1200000,
            duration: 0,
            language: 5575,
            quality: 0,
          },
          {
            _t: 'hdlr',
            version: 0,
            flags: 0,
            componentType: '\u0000\u0000\u0000\u0000',
            componentSubtype: 'vide',
            componentManufacturer: 0,
            componentFlags: 0,
            componentFlagsMask: 0,
            componentName: 'VideoHandler\u0000',
          },
          {
            _t: 'minf',
            _b: [
              {
                _t: 'dinf',
                _b: [
                  {
                    _t: 'dref',
                    version: 0,
                    count: 1,
                    _b: [
                      {
                        _t: 'url ',
                        _d: '00000001',
                      },
                    ],
                  },
                ],
              },
              {
                _t: 'stbl',
                _b: [
                  {
                    _t: 'stsd',
                    version: 0,
                    flags: 0,
                    count: 1,
                    _b: [
                    ],
                  },
                  {
                    _t: 'stts',
                    version: 0,
                    flags: 0,
                    count: 0,
                  },
                  {
                    _t: 'stsc',
                    _d: '0000000000000000',
                  },
                  {
                    _t: 'stsz',
                    version: 0,
                    flags: 0,
                    count: 0,
                  },
                  {
                    _t: 'stco',
                    version: 0,
                    flags: 0,
                    count: 0,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  }, // trak

  mvex: {
    _t: 'mvex',
    _b: [
      {
        _t: 'trex',
        _d: '000000000000000100000001000000000000000000000000',
      },
    ],
  }, // mvex

  vmhd: {
    _t: 'vmhd',
    version: 0,
    flags: 1,
    graphicsMode: 0,
    opcolor_red: 0,
    opcolor_green: 0,
    opcolor_blue: 0,
  }, // vmhd

  avc1: {
    _t: 'avc1',
    reserved1: '000000000000',
    dataReferenceIndex: 1,
    version: 0,
    revisionLevel: 0,
    vendor: 0,
    temporalQuality: 0,
    spatialQuality: 0,
    width: 1280,
    height: 960,
    horizontalResolution: '72.0',
    verticalResolution: '72.0',
    dataSize: 0,
    frameCount: 1,
    compressorName: '\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000\u0000',
    depth: 24,
    colorTableId: 65535,
    _b: [
      {
        _t: 'avcC',
        configurationVersion: 1,
        AVCProfileIndication: 77,
        profileCompatibility: 0,
        AVCLevelIndication: 41,
        lengthSizeMinusOne: 3,
        sequenceParameterSets: [
          '674d0029e2900a00f3602dc040406907891150',
        ],
        pictureParameterSets: [
          '68ee3c8000',
        ],
      },
      {
        _t: 'pasp',
        hSpacing: 1,
        vSpacing: 1,
      },
    ],
  }, // avc1

  nmhd: {
    _t: 'nmhd',
    version: 0,
    flags: 0,
  }, // nmhd

  tx3g: {
    _t: 'tx3g',
    reserved1: '000000000000',
    dataReferenceIndex: 1,
    display_flags: 0x00000000,
    halign: 1, // 0=left, 1=center, -1=right
    valign: 255, // 0=top, 1=center, -1=bottom
    bgcolor: 0x00000000,
    box_top: 0,
    box_left: 0,
    box_bottom: 0,
    box_right: 0,
    style: 0x00000000,
    font_id: 1,
    font_face: 0,
    font_size: 18,
    color: 0xFFFFFFFF,
    _b: [
      {
        _t: 'ftab',
        count: 1,
        font_id: 1,
        font_name_length: 5,
        font_name: 'Serif',
      },
    ],
  }, // tx3g

  moof: {
    _t: 'moof',
    _b: [
      {
        _t: 'mfhd',
        version: 0,
        flags: 0,
        sequenceNumber: 9,
      },
      {
        _t: 'traf',
        _b: [
          {
            _t: 'tfhd',
            version: 0,
            flags: 131128,
            trackId: 1,
            defaultSampleDuration: 48000,
            defaultSampleSize: 282,
            defaultSampleFlags: 16842752,
          },
          {
            _t: 'tfdt',
            version: 1,
            flags: 0,
            baseMediaDecodeTime: 384000,
          },
          {
            _t: 'trun',
            version: 0,
            flags: 1,
            sampleCount: 1,
            dataOffset: 108,
          },
        ],
      },
    ],
  }, // moof

  moof_keyframe: {
    _t: 'moof',
    _b: [
      {
        _t: 'mfhd',
        version: 0,
        flags: 0,
        sequenceNumber: 1,
      },
      {
        _t: 'traf',
        _b: [
          {
            _t: 'tfhd',
            version: 0,
            flags: 131128,
            trackId: 1,
            defaultSampleDuration: 48000,
            defaultSampleSize: 40588,
            defaultSampleFlags: 16842752,
          },
          {
            _t: 'tfdt',
            version: 1,
            flags: 0,
            baseMediaDecodeTime: 0,
          },
          {
            _t: 'trun',
            version: 0,
            flags: 5,
            sampleCount: 1,
            dataOffset: 112,
            firstSampleFlags: 33554432,
          },
        ],
      },
    ],
  }, // moof_keyframe

} // TEMPLATES

for(const name in BMFF.TEMPLATES) {
  BMFF.TEMPLATES[name] = JSON.stringify(BMFF.TEMPLATES[name])
}
